import axios from 'axios'

let MODE = /*process.env.REACT_APP_MODE ||*/ 'DEVELOPMENT'

let BASE_URL = ''
if (MODE === 'DEVELOPMENT') {
  // BASE_URL = 'https://api.taskplanet.org'
  // BASE_URL = 'https://taskplanet-backend.herokuapp.com'
  BASE_URL = 'http://localhost:7000'
} else if (MODE === 'PRODUCTION') {
  BASE_URL = 'https://api.taskplanet.org'
}

const instance = axios.create({
  baseURL: `${BASE_URL}`,
  timeout: 15000,
})

const responseBody = (response) => response.data

const requests = {
  get: (url, headers) => instance.get(url, headers).then(responseBody),
  post: (url, body, config) => instance.post(url, body, config).then(responseBody),
  patch: (url, body) => instance.patch(url, body).then(responseBody),
  delete: (url) => instance.delete(url).then(responseBody),
}

export default requests
